import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {api} from '../../../api';
import {_decodeData} from '../../../api/helpers';
import {reset} from "../../login/components/loginSlice";

export const getVenueContacts = createAsyncThunk(
  'contactList/getVenueContacts', // function name to call in login screen
  async ({body,token}, thunkAPI) => {
    try {
      const response = await  api.post('contacts/','getVenueContacts',body,token);
      let data = await response.json();
      if (response.status === 200) {
        return {
          status: true,
          msg: ' Success',
          apiRet: await _decodeData(data),
        };
      } else {
         // call logout hhere
         return thunkAPI.dispatch(reset({}));
      }
    } catch (e) {
      return thunkAPI.rejectWithValue({
        status: false,
        msg: ' failed',
        apiRet: {errors:[]},
      });
    }
  },
);


// Slice
const ContactListSlice = createSlice({
  name: 'contactList',
  initialState : {
      list : [],
      isFetching : false,
      isError    : false,
      selected   : '',
  },
  reducers: {
    assignState2: (state, action) => {
      const {slicekey, value} = action.payload;
      state[slicekey] = value;
    },
  },
  extraReducers: {
    [getVenueContacts.fulfilled]: (state, {payload}) => {
      state.isError    = false;
      state.list       = payload.apiRet;
      state.isFetching = false;
    },
    [getVenueContacts.rejected]: (state, {payload}) => {
      state.isFetching = false;
      state.isError    = true;
    },
    [getVenueContacts.pending]: (state) => {
      state.isFetching = true;
      state.isError    = false;
    },
  },
});

export const {assignState2} = ContactListSlice.actions;
export default ContactListSlice.reducer;
